import React, { useEffect } from 'react';
import './TACardWidget.scss';
import { useAxios } from 'hooks/useAxios';
import { getDataFromSingleEndpoint } from 'services/Torogoz/TogorozApi';
import { useStore as useGlobalStore } from 'store/useGlobalStore';
import libraryComponents from 'components';
import LoadingSpinner from 'core-ui/LoadingSpinner/LoadingSpinner';
import CardTitle from 'components/CardTitle/CardTitle';
import CardFooterActions from 'components/CardFooterActions/CardFooterActions';

interface TACardWidgetProps {
  selectedWidget?: any;
  setSelectedWidget?: any;
  [x: string]: any;
}

const TACardWidget: React.FC<TACardWidgetProps> = ({
  selectedWidget,
  setSelectedWidget,
  ...widget
}) => {
  const { payload, displayName } = widget;
  const ChildComponent = libraryComponents[widget.alias];
  const { response, axiosFetch, loading, error } = useAxios();

  const dataAvailable = () => {
    if (!response?.data || Object.keys(response.data).length === 0) return false;

    return Object.values(response.data).some((value) => {
      if (value == null) return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return true;
    });
  };

  const { endpoints, dataSourceType, dateFilter } = useGlobalStore((state) => ({
    endpoints: state.endpoints,
    dataSourceType: state.dataSourceType,
    dateFilter: state.dateFilter,
  }));

  const getData = async () => {
    const hasIntervalType = Boolean(dateFilter?.interval_type);
    const needsRange = dateFilter?.interval_type === 'custom';
    const hasRange = Boolean(dateFilter?.start_date && dateFilter?.end_date);

    if (!hasIntervalType || (needsRange && !hasRange)) return;

    const payloadWithDateFilter = {
      ...payload,
      filters: {
        ...payload.filters,
        date_interval: dateFilter,
      },
    };
    await getDataFromSingleEndpoint(endpoints.getWidgetData, payloadWithDateFilter, axiosFetch);
  };

  useEffect(() => {
    getData();
  }, [dateFilter]);

  return (
    <>
      <div>
        <div
          className={`ta-card ${loading ? 'ta-card-loading' : ''}`}
          onClick={setSelectedWidget ? () => setSelectedWidget(widget) : undefined}
        >
          {loading ? null : (
            <CardTitle
              displayName={displayName}
              viewName=""
              isMetricWidget={false}
              showWarning={false}
              warningValidData={false}
              isActions={false}
            />
          )}
          {loading ? (
            <LoadingSpinner />
          ) : !dataAvailable() ? (
            <div className="ta-card-no-data">
              <div className="ta-card-no-data-message">No Data Available</div>
            </div>
          ) : (
            <ChildComponent
              {...widget}
              response={response}
              loading={loading}
              error={error}
              dataSourceType={dataSourceType}
            />
          )}
          {loading ? null : (
            <CardFooterActions {...{ actions: widget?.options?.actions, response }} />
          )}
        </div>
        {!loading && selectedWidget?.id === widget.id ? (
          <div className="ta-selected">
            <div className="arrow"></div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TACardWidget;
